import React from "react";
import "./Content.css";

export default function Content() {
  const videoStyle = {
    pointerEvents: 'none' // Prevents interaction with video controls
  };

  const preventContextMenu = (e) => {
    e.preventDefault(); // Prevents right-click context menu
  };

  return (
    <div className="container text-center">
      <h2 className="dropdown-title">Exquisite Wedding Hampers, Tailored by Us</h2>
      <div className="row">
        <div className="col-12 col-md-4 mb-4">
          <video 
            className="video-player" 
            controls 
            controlsList="nodownload" 
            muted 
            autoPlay 
            loop 
            onContextMenu={preventContextMenu} 
            style={videoStyle}>
            <source src="/thedata/allbaskets.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
        <div className="col-12 col-md-4 mb-4">
          <video 
            className="video-player" 
            controls 
            controlsList="nodownload" 
            muted 
            autoPlay 
            loop 
            onContextMenu={preventContextMenu} 
            style={videoStyle}>
            <source src="/thedata/new.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="col-12 col-md-4 mb-4">
          <video 
            className="video-player" 
            controls 
            controlsList="nodownload" 
            muted 
            autoPlay 
            loop 
            onContextMenu={preventContextMenu} 
            style={videoStyle}>
            <source src="/thedata/n.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
}